import type { ComponentInternalInstance } from 'vue';
import type { IRoleCapability } from '@platform/shared/lib/roles/types';
import { stableJsonStringify } from '@platform/shared/helpers/role-helpers';

const MAX_SEARCH_DEPTH = 7;

export function checkIsInMainView(componentParent: ComponentInternalInstance['parent']) {
    let isInMainView = false;

    // @ts-ignore
    let parent = componentParent;
    for (let i = 0; i < MAX_SEARCH_DEPTH; i++) {
        if (!parent) break;
        if (parent?.type?.name === 'RouterView' || (parent?.type as any)?.enableRoleChecks) {
            isInMainView = true;
            break;
        }
        parent = parent.parent;
    }
    return isInMainView;
}

export function findAppropriateCompProps(
    comp: string | null,
    compProps: any,
    capabilities?: Map<string, IRoleCapability>
) {
    if (!comp) return { c: null, cp: null };
    if (!capabilities) return { c: comp, cp: compProps };
    const cp = stableJsonStringify(compProps || null);
    if (capabilities.has(`component:${comp}^${cp}`)) return { c: comp, cp: compProps || null };
    const capabilitiesList = [...capabilities.keys()].filter((c) => c.startsWith(`component:${comp}^`));
    if (capabilitiesList.length === 1) {
        const str = capabilitiesList[0];
        const cap = capabilities.get(str);
        if (cap?.type === 'component') {
            return { c: comp, cp: cap.component_props || null };
        }
        const cpJson = str.substring(str.indexOf('^') + 1);
        return { c: comp, cp: JSON.parse(cpJson) };
    } else {
        for (const k of capabilitiesList) {
            const cap = capabilities.get(k);
            if (cap?.type === 'component' && cap['arePropsMatches']?.(compProps)) {
                return cap.component_props;
            }
        }
        return { c: comp, cp: compProps || null };
    }
}
